(function() {
  class ProductLabelsBlock extends HTMLElement {
    static observedGalleries = new WeakSet();
    static initializedLabels = new WeakSet();

    constructor() {
      super();
      this.galleryEl = null;
      this.observer = null;
    }

    connectedCallback() {
      if (ProductLabelsBlock.initializedLabels.has(this)) return;
      ProductLabelsBlock.initializedLabels.add(this);

      this.galleryEl = this.closest('product-card')?.querySelector('[ref="cardGallery"], .card-gallery');
      if (!(this.galleryEl instanceof HTMLElement)) return;

      this.setHeight();
      requestAnimationFrame(() => this.setHeight());

      if ('ResizeObserver' in window && !ProductLabelsBlock.observedGalleries.has(this.galleryEl)) {
        ProductLabelsBlock.observedGalleries.add(this.galleryEl);
        this.observer = new ResizeObserver(() => this.setHeight());
        this.observer.observe(this.galleryEl);
      }
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
        ProductLabelsBlock.observedGalleries.delete(this.galleryEl);
      }
    }

    setHeight() {
      if (!this.galleryEl) return;

      let height = this.galleryEl.getBoundingClientRect().height;
      if (!height) {
        const firstChild = this.galleryEl.firstElementChild;
        height = firstChild instanceof HTMLElement ? firstChild.getBoundingClientRect().height : 0;
      }

      if (height > 0) {
        this.style.setProperty('--custom-product-labels-gallery-height', `${height}px`);
        this.dataset.heightReady = 'true';
      }
    }

    static initAll(container) {
      container.querySelectorAll('.custom-product-labels').forEach(el => {
        if (el instanceof ProductLabelsBlock) return;
        customElements.upgrade(el);
        if (el instanceof ProductLabelsBlock) {
          el.connectedCallback();
        }
      });
    }

    static observeRecommendations(recommendationsEl) {
      new MutationObserver((mutations, observer) => {
        for (const { addedNodes } of mutations) {
          for (const node of addedNodes) {
            if (node instanceof HTMLElement) {
              this.initAll(node);
            }
          }
        }
        if (recommendationsEl.querySelector('.custom-product-labels')) {
          observer.disconnect();
        }
      }).observe(recommendationsEl, { childList: true, subtree: true });
    }

    static initRecommendations() {
      document.querySelectorAll('.product-recommendations').forEach(el => {
        if (!(el instanceof HTMLElement)) return;
        if (el.querySelector('.custom-product-labels')) {
          this.initAll(el);
        } else {
          this.observeRecommendations(el);
        }
      });
    }
  }

  if ('customElements' in window) {
    customElements.define('product-labels-block', ProductLabelsBlock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      ProductLabelsBlock.initAll(document);
      ProductLabelsBlock.initRecommendations();
    });
  } else {
    ProductLabelsBlock.initAll(document);
    ProductLabelsBlock.initRecommendations();
  }

  document.addEventListener('shopify:section:load', (e) => {
    if (e.target instanceof HTMLElement) {
      ProductLabelsBlock.initAll(e.target);
    }
  });
})();
